import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  FormGroup,
  FormBuilder,
  Validators,
  ValidatorFn,
  AbstractControl,
  ValidationErrors,
} from "@angular/forms";
import { ComponentBase } from "../base/component-base";
import { UtilService } from "../service/util.service";
import { ISelectionBox } from "../model/ISelectionBox";
import { CookiesLocalService } from "../service/cookies-local.service";
import { ApplicantService } from "../service/applicant.service";
import { BehaviorModelChangeService } from "../service/behavior-model-change.service.service";

@Component({
  selector: "app-personal-info",
  templateUrl: "./personal-info.component.html",
  styleUrls: ["./personal-info.component.css"],
})
export class PersonalInfoComponent extends ComponentBase implements OnInit {
  marketingMethods: { ValueId: string; DisplayValue: string }[];
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private utilService: UtilService,
    cookieLocal: CookiesLocalService,
    applicantService: ApplicantService,
    behaviorModelChangeService: BehaviorModelChangeService
  ) {
    super(applicantService, cookieLocal, behaviorModelChangeService);
  }
  title = "Please tell us about yourself.";
  basicApplicantInfo: FormGroup;
  ethnicGroups: ISelectionBox[];
  maritalStatus: ISelectionBox[];
  religions: ISelectionBox[];
  disabilities: ISelectionBox[];
  titles: ISelectionBox[];
  genders: ISelectionBox[];

  yesOrNo = [
    { Name: "Yes", Id: true },
    { Name: "No", Id: false },
  ];
 

  ngOnInit() {
    this.basicApplicantInfo = this.getPersonalBio(this.applicantData);

    // setting dynamic validator
    this.setDisabilityValidators();
    this.getLoadData();
    this.showLoadingIndicator = false;
  }

  getPersonalBio(data): FormGroup {
    return this.fb.group({
      FirstName: [data.FirstName, Validators.required],
      LastName: [data.LastName, Validators.required],
      OtherName: [data.OtherName],
      MarritalStatusId: [data.MarritalStatusId, Validators.required],
      GenderId: [data.GenderId, Validators.required],
      TitleId: [data.TitleId, Validators.required],
      DateOfBirth: [data.DateOfBirthDisplay, Validators.required],
      EthnicGroupId: [data.EthnicGroupId],
      IsDisability: [data.IsDisability, Validators.required],
      DisabilityReason: [data.DisabilityReason],
      // DisabilityId:[data.DisabilityId,Validators.required],
      PlaceOfBirth: [data.PlaceOfBirth, Validators.required],
      ReligionId: [data.ReligionId, Validators.required],
      WhyUs: [data.WhyUs, Validators.required],
      MarketingMethodId: [data.MarketingMethodId, Validators.required],
      WhyEngineering: [data.WhyEngineering, Validators.required],
    });
  }

  setDisabilityValidators() {
    // const isDisabilityControl = this.basicApplicantInfo.get('institution');
    const disabilityReasonControl =
      this.basicApplicantInfo.get("DisabilityReason");

    this.basicApplicantInfo
      .get("IsDisability")
      .valueChanges.subscribe((isDisability) => {
        if (isDisability === "true") {
          disabilityReasonControl.setValidators([Validators.required]);
        } else {
          disabilityReasonControl.setValidators(null);
        }
        // isDisabilityControl.updateValueAndValidity();
        disabilityReasonControl.updateValueAndValidity();
      });
  }

  getDisabilityReason() {
    const val = this.basicApplicantInfo.controls.IsDisability.value;
    if (val === "true") {
      return false;
    } else {
      return true;
    }
  }

  getLoadData() {
    this.utilService.getEthnicGroups().subscribe((data) => {
      this.ethnicGroups = data.map((item) => ({
        ValueId: item.ValueId,
        DisplayValue: item.DisplayValue.toUpperCase(),
      }));
    });
    this.utilService.getMarketingMethods().subscribe((data) => {
      this.marketingMethods = data.map((item) => ({
        ValueId: item.ValueId,
        DisplayValue: item.DisplayValue.toUpperCase(),
      }));
    });
    this.utilService
      .getMaritalStatuses()
      // tslint:disable-next-line: max-line-length
      .subscribe((data) => {
        this.maritalStatus = data.map((item) => ({
          ValueId: item.ValueId,
          DisplayValue: item.DisplayValue.toUpperCase(),
        }));
      });
    this.utilService.getReligions().subscribe((data) => {
      this.religions = data.map((item) => {
        return {
          ValueId: item.ValueId,
          DisplayValue: item.DisplayValue.toUpperCase(),
        };
      });
    });
    this.utilService.getDisabilities().subscribe((data) => {
      this.disabilities = data.map((item) => {
        return {
          ValueId: item.ValueId,
          DisplayValue: item.DisplayValue.toUpperCase(),
        };
      });
    });
    this.utilService.getTitles().subscribe((data) => {
      this.titles = data.map((item) => {
        return {
          ValueId: item.ValueId,
          DisplayValue: item.DisplayValue.toUpperCase(),
        };
      });
    });

    this.utilService.getGenders().subscribe((data) => {
      this.genders = data.map((item) => {
        return {
          ValueId: item.ValueId,
          DisplayValue: item.DisplayValue.toUpperCase(),
        };
      });
    });
  }

  goToNext(form: any) {
    const data = this.basicApplicantInfo.value;
    const model = this.cookieLocal.getApplicantData();
    model.FirstName = data.FirstName;
    model.LastName = data.LastName;
    model.OtherName = data.OtherName;
    model.MarritalStatusId = data.MarritalStatusId;
    model.GenderId = data.GenderId;
    model.TitleId = data.TitleId;
    model.DateOfBirth = data.DateOfBirth;
    model.EthnicGroupId = data.EthnicGroupId;
    model.DisabilityId = data.DisabilityId;
    model.PlaceOfBirth = data.PlaceOfBirth;
    model.ReligionId = data.ReligionId;
    model.IsDisability = data.IsDisability;
    model.DisabilityReason = data.DisabilityReason;
    model.EntryTypeId = data.EntryTypeId;
    model.WhyUs = data.WhyUs;
    model.WhyEngineering = data.WhyEngineering;
    model.MarketingMethodId = data.MarketingMethodId;
    this.applicantService.savePersonalData(model).subscribe(
      (val) => {
        this.cookieLocal.getRefreshedApplicantData(model);
        this.router.navigate(["/applicant/info/personal/contact"]);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  goToPrevious(form: any) {
    this.router.navigate(["/applicant/info/upload-image"]);
  }

  getFullName() {
    if (this.basicApplicantInfo) {
      let lastName = this.basicApplicantInfo.value.LastName;
      let middleName = this.basicApplicantInfo.value.MiddleName;
      let firstName = this.basicApplicantInfo.value.FirstName;

      let fullName = lastName ?? "".trim() + ", ";
      fullName += firstName ?? " ";

      fullName += middleName ?? "";
      // console.log(fullName);
      return fullName;
    }

    return "";
  }
}
